import { createContext, useContext } from 'react'

export const ToolLayoutContext = createContext(false)

export const useToolLayout = () => useContext(ToolLayoutContext)
